import type { ChapterProposalReady, ProposalDraft, ProposalDraftChapter } from "@contract";

export interface DraftChapter extends ProposalDraftChapter {
  firstLine: string | null;
  wordCount: number | null;
  proposalExcluded: boolean;
  reason: string | null;
}
export interface ChapterDraft {
  chapters: DraftChapter[];
  calibrationStart: number;
}

export function fromProposal(proposal: ChapterProposalReady): ChapterDraft {
  const calibration = proposal.chapters.find((row) => row.id === proposal.calibrationChapterId);
  return {
    chapters: proposal.chapters.map((row) => ({
      title: row.title,
      nodeStart: row.nodeStart,
      excluded: row.excluded,
      firstLine: row.firstLine,
      wordCount: row.wordCount,
      proposalExcluded: row.proposalExcluded,
      reason: row.reason,
    })),
    calibrationStart:
      calibration?.nodeStart ?? proposal.chapters.find((row) => !row.excluded)?.nodeStart ?? 0,
  };
}

export function normalizeCalibration(draft: ChapterDraft): ChapterDraft {
  if (draft.chapters.some((row) => row.nodeStart === draft.calibrationStart && !row.excluded))
    return draft;
  return {
    ...draft,
    calibrationStart: draft.chapters.find((row) => !row.excluded)?.nodeStart ?? -1,
  };
}

export function mergeUp(draft: ChapterDraft, index: number): ChapterDraft {
  const current = draft.chapters[index];
  const previous = draft.chapters[index - 1];
  if (!current || !previous) return draft;
  const chapters = draft.chapters.filter((_, at) => at !== index);
  chapters[index - 1] = {
    ...previous,
    wordCount:
      previous.wordCount === null || current.wordCount === null
        ? null
        : previous.wordCount + current.wordCount,
  };
  return normalizeCalibration({
    chapters,
    calibrationStart:
      draft.calibrationStart === current.nodeStart ? previous.nodeStart : draft.calibrationStart,
  });
}

export function wireDraft(draft: ChapterDraft): ProposalDraft {
  return {
    chapters: draft.chapters.map(({ title, nodeStart, excluded }) => ({
      title,
      nodeStart,
      excluded,
    })),
    calibrationIndex: draft.chapters.findIndex((row) => row.nodeStart === draft.calibrationStart),
  };
}
